import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import ServiceIconBox from '../container/service/ServiceIconBox';
import ContactInformationThree from '../container/ContactInformation/ContactInformationThree';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import GoogleMap from "../container/Map/GoogleMap";
import TestimonialPopUp from '../container/Testimonial/TestimonialPopUp';
import ChatWidget from "../components/ChatWidget/ChatWidget";

const capitalize = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());

const Service = () => {
    const last = window.location.pathname.slice(window.location.pathname.lastIndexOf("/")+1 , window.location.pathname.length)
    const isServiceArea = last.includes('virginia') || last.includes('maryland') || last.includes('dc');
    let endText = '';
    if (isServiceArea) {
        let text = capitalize(last.replace('-', ' ').replace(' dc', ' DC'));
        if (text.includes('-')) {
            text = capitalize(text.replace('-', ' '))
        }
        endText = ` in ${text}`;
    }
    return (
        <React.Fragment>
            <SEO title={`Insulation${endText} - Founders Insulation`} description={`Discover our comprehensive range of insulation services${endText} designed to optimize comfort and energy efficiency in your home or business. From insulation installation and upgrades to energy audits and consultations, our expert team delivers tailored solutions to meet your specific needs. Explore how our cutting-edge techniques and premium materials can enhance your space's insulation performance, saving you money and reducing energy consumption.`} />
            <Header />
            <Breadcrumb
                image="images/bg/breadcrumb-bg-five.webp"
                title="We are Founders Insulation"
                content="Home"
                contentTwo="Service area"
            />
            <ServiceIconBox endText={endText} />
            <GoogleMap />
            <ContactInformationThree />
            <Footer />
            <ChatWidget />
            <ScrollToTop />
            <TestimonialPopUp />
        </React.Fragment>
    )
}

export default Service;

